/* istanbul ignore file */
import { theme } from '@noths/polaris-client-ribbons-base';
import { ICON_BUTTON__ICON_CLASS } from '@noths/polaris-client-ribbons-design-system';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

import { ACCORDION__CONTENT_WRAPPER_CLASS, ACCORDION__HEADING_CLASS } from './constants/classNames';

export const accordion = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .${ACCORDION__HEADING_CLASS} {
    margin: 0;
  }

  .js & {
    .${ACCORDION__CONTENT_WRAPPER_CLASS} {
      width: 100%;
      transition: height 0.5s;
      height: 0;
      overflow: hidden;
      > div {
        margin-top: ${pxToRem(spacing.xl)};
      }
    }
  }
`;

export const accordionButton = css`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  background: none;
  border: none;

  .${ICON_BUTTON__ICON_CLASS} {
    transform: rotate(180deg);
    transition: transform 0.5s;
  }
  &[data-is-open='true'] {
    .${ICON_BUTTON__ICON_CLASS} {
      transform: rotate(0deg);
    }
  }

  @media (hover: hover) {
    &:hover {
      background: none;
    }
  }
`;

export const accordionTitle = css`
  margin-right: ${pxToRem(spacing.sm)};
  text-transform: capitalize;
`;
